import { gql } from '@efficiently/client-core-graphql-models';

export const CREATE_FINISHES = gql(`
	mutation ProjectLocationCreateFinishes($projectId: String!, $finishes: [FinishInput!]!) {
		createFinishes(projectId: $projectId, finishes: $finishes) {
			...FinishDomainFinishFields
		}
	}
`);

// TODO(EFF-21352): (createdFinishIds) replace inline copy with FINISH_ID_FIELDS from data-access-finish-id
//
// `itemIdType` is in that copy because the ID Type pill renders from it: the pill paints its label white
// and takes its background from the type, so an Item ID that arrives without one shows as blank space
// that still opens the Product/Spec menu. The server always has a value (`finish_id.item_id_type`
// defaults to `Product`), so the gap was only ever this selection set — which is what an inline copy of a
// fragment costs. Anything added to `FinishIdFields` that the Item ID card reads has to be added here too
// until the TODO above is done.
export const CREATE_FINISHES_WITH_CASCADE = gql(`
	mutation CreateFinishesCascade($projectId: String!, $finishes: [FinishInput!]!) {
		createFinishesCascade(projectId: $projectId, finishes: $finishes) {
			finishes {
				...FinishDomainFinishFields
			}
			cascade {
				finishIds {
					_id
					status
				}
				finishes {
					_id
					status
				}
			}
			createdFinishIds {
				_id
				createdDate
				createdById
				lastModifiedDate
				lastModifiedById
				orgId
				projectId
				category
				color
				croppedImage
				division
				image
				index
				isDeleted
				itemId
				itemIdType
				itemNotes
				installationNotes
				keyLabel
				label
				lastItemUpdateDate
				procurementNotes
				procurementType
				remarks
				sortOrder
				status
				subtype
				type
				unitOfMeasure
				wastage
				rate
			}
		}
	}
`);
